





















































import { Vue, Component, Prop, Watch } from "vue-property-decorator";

// Types
import {
  ISortableOptions,
  ISortableData,
  ISortableRouterLink
} from "@/models/reordering";

@Component
export default class ReorderingVessels extends Vue {
  // Props
  @Prop({ required: true })
  public sortableData!: ISortableData[];

  @Prop({ required: true })
  public reorder!: Function;

  @Prop({ default: null })
  public refreshOrder!: Function;

  @Prop({ default: null })
  public routerLink!: ISortableRouterLink;

  @Prop({ required: true })
  public sortableItemName!: string;

  @Prop({ default: true })
  public isReorderable!: boolean;

  @Prop({ default: false })
  public isDisabled!: boolean;

  // Variables
  public sortElems: ISortableData[] = [];
  public savedOrder: ISortableData[] = [];

  public isReordering = false;

  public sortableOptions: ISortableOptions = {
    chosenClass: "dragged-vessel",
    handle: ".vessel-draggable"
  };

  public async onDragDrop() {
    this.isReordering = true;
    this.savedOrder = this.$_.cloneDeep(this.sortElems);

    try {
      await this.reorder(
        this.$_.map(this.sortElems, sortedElem => {
          return sortedElem.id;
        })
      );
      if (this.refreshOrder) {
        await this.refreshOrder();
      }
      this.$store.dispatch("toast/show", {
        message: this.$t("_.order_updated")
      });
    } catch (error) {
      this.sortElems = this.$_.cloneDeep(this.savedOrder);
      this.$buefy.toast.open({
        message: error.message,
        type: "is-danger"
      });
    }

    this.isReordering = false;
  }

  public getRouterLink(sortElem) {
    return this.$_.isEmpty(this.routerLink)
      ? null
      : this.$_.merge(
          {},
          this.$_.has(this.routerLink, "name")
            ? { name: this.routerLink.name }
            : {},
          this.$_.has(this.routerLink, "path")
            ? { path: this.routerLink.path }
            : {},
          this.$_.isEmpty(this.routerLink.params)
            ? {}
            : {
                params: this.$_.mapValues(
                  this.routerLink.params,
                  valueKey => sortElem[valueKey]
                )
              }
        );
  }

  // Watch
  @Watch("sortableData", { immediate: true })
  public updateSortableData() {
    this.sortElems = this.$_.cloneDeep(this.sortableData);
    this.savedOrder = this.$_.cloneDeep(this.sortElems);
  }
}
